import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";

export const useOrgAdmin = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentOrg, setCurrentOrg] = useState(null); // Store the org being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentOrg(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((org) => {
    setEditMode(true);
    setCurrentOrg(org);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isLargeScreen,
    open,
    editMode,
    currentOrg,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  };
};
